import { ICON_NAMES } from '@/config/config';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { SizedIconWithCircle } from '../../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../../shared/components/Text';

export const reportIdFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'id',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    disableOnRowClick: true,
    renderCell: (rowData: { row: { id: string } }) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.button}
          iconName={ICON_NAMES.REPORTS}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_REPORT_ID' }}
        />
      );
    },
  };
};
